import React, { Component } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { formValueSelector } from "redux-form";
import moment from "moment";
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";
import ListingItem from "../ListingItem/ListingItem";
import { calculateTotalPrice } from "../../../helpers/calculateTotalPrice";
import cs from "../../../components/commonStyle.css";
import s from "./SearchResults.css";

class ListingItemsData extends Component {
  render() {
    const { results, guests, base, rates, toCurrency, dates } = this.props;
    const { formatMessage } = this.props.intl;
    const today = moment().format('YYYY-MM-DD');
    const tomorrow = moment().add(1, 'day').format('YYYY-MM-DD');
    const defaultDates = `'${today}' AND '${tomorrow}'`;
    return (
      <div className={cx(cs.displayFlex, cs.flexWrap, 'listItempopUpSection')}>
        {results.map((item, listIndex) => {
          const effectiveDates = item?.listingData?.dates || dates || defaultDates;
          const calculatedValues = calculateTotalPrice({
            listingData: { ...item?.listingData, dates: effectiveDates },
            listBlockedDates: item?.blockedDates,
            serviceFees: item?.serviceFees,
            base,
            rates,
            guests,
            formatMessage,
            toCurrency
          });
          return (
            <div className={cx(s.listItem, 'listItempopUp')} key={item?.id}>
              <ListingItem
                id={item?.id}
                basePrice={item?.listingData?.basePrice}
                currency={item?.listingData?.currency}
                title={item?.title}
                beds={item?.beds}
                personCapacity={item?.personCapacity}
                roomType={item?.settingsData[0]?.listsettings?.itemName}
                coverPhoto={item?.coverPhoto}
                listPhotos={item?.listPhotos}
                bookingType={item?.bookingType}
                reviewsCount={item?.reviewsCount}
                reviewsStarRating={item?.reviewsStarRating}
                wishListStatus={item?.wishListStatus}
                isListOwner={item?.isListOwner}
                personCount={guests}
                oneTotalPrice={item?.listingData?.oneTotalPrice}
                listBlockedDates={item?.blockedDates}
                serviceFees={item?.serviceFees}
                calculatedValues={calculatedValues}
              />
            </div>
          );
        })}
      </div>
    );
  }
}
const selector = formValueSelector("SearchForm");

const mapState = (state) => ({
  base: state?.currency?.base,
  rates: state?.currency?.rates,
  toCurrency: state?.currency?.to || state?.currency?.base,
  dates: selector(state, "dates"),
});
export default injectIntl(withStyles(s, cs)(connect(mapState)(ListingItemsData)));